import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito ser chef o saber cocinar bien?',
    a: 'No. Todas las recetas están diseñadas para personas ocupadas sin tiempo ni experiencia culinaria avanzada. Máximo 20 minutos y pasos simples.'
  }, {
    q: '¿Los ingredientes son difíciles de encontrar?',
    a: 'Todo lo encontrarás en cualquier supermercado. Incluimos la Lista del Súper Inteligente para que tu compra semanal sea rápida y económica.'
  }, {
    q: '¿Funciona para hombres también?',
    a: 'Absolutamente. Las recetas están diseñadas para el metabolismo de adultos de 40+ en general, tanto hombres como mujeres.'
  }, {
    q: '¿Cómo recibo el producto?',
    a: 'Al completar tu pago recibirás un correo con el enlace de descarga inmediata. Acceso instantáneo desde cualquier dispositivo.'
  }, {
    q: '¿Qué pasa si no me funciona?',
    a: 'Ofrecemos garantía de satisfacción. Si en los primeros 7 días no estás satisfecho/a, te devolvemos tu dinero sin preguntas.'
  }, {
    q: '¿Por qué el precio es tan bajo?',
    a: 'Estamos en período de lanzamiento y queremos que el máximo de personas de 40+ puedan acceder. Este precio es temporal y subirá pronto.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-ivory py-20 px-6" data-id="element-30">
      <div className="max-w-[800px] mx-auto" data-id="element-31">
        <h2 className="font-serif text-3xl md:text-4xl text-botanic text-center mb-12" data-id="element-32">
          Preguntas Frecuentes
        </h2>

        <div className="flex flex-col gap-4" data-id="element-33">
          {faqs.map((faq, i) => <div key={i} className="bg-white rounded-xl shadow-sm border border-alt-section overflow-hidden" data-id="element-34">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" aria-expanded={openIndex === i} data-id="element-35">
                <span className="font-bold text-botanic pr-4 flex gap-3" data-id="element-36">
                  <span className="text-gold" data-id="element-37">❓</span> {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-sage transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-38" />
              </button>

              <AnimatePresence data-id="element-39">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-40">
                    <div className="p-6 pt-0 text-ink-soft border-t border-alt-section/50 flex gap-3" data-id="element-41">
                      <span className="text-green-500" data-id="element-42">✅</span>
                      <p data-id="element-43">{faq.a}</p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}